import { isAxiosError } from "axios";

import {
  AiGetExperienceAnalysisRequestBodyType,
  AiGetExperienceAnalysisResponseBodyType,
} from "@intelligems/ig-types";
import { useMutation } from "@tanstack/react-query";

import { api } from "../api";
import { ApiRequest } from "../types/api";

export const getExperienceAnalysis = async (
  data: ApiRequest<AiGetExperienceAnalysisRequestBodyType, any, any>
) => {
  const resp = await api.post<AiGetExperienceAnalysisResponseBodyType>(
    `/v2/ai/prompts/experience-analysis`,
    data.body
  );
  return resp.data;
};

export const useExperienceAnalysis = () => {
  return useMutation<
    AiGetExperienceAnalysisResponseBodyType,
    Error,
    ApiRequest<AiGetExperienceAnalysisRequestBodyType, any, any>,
    any
  >({
    mutationFn: async (data) => getExperienceAnalysis(data),
    onError: (error) => {
      if (isAxiosError(error)) {
        if (error.response?.status === 503) {
          return;
        }
      }
    },
  });
};
